<template>
  <div class="settle-account-row">
    <div class="settle-account-table">
      <vxe-grid
        v-if="tableStatus"
        border
        show-footer
        :footer-method="footerMethod"
        show-overflow
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @radio-change="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        height="300"
      >
        <template v-slot:buttons v-if="isCreate">
          <!-- <el-button
            @click="$refs.settleAccountsRef.commitProxy('insert_actived')"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            >新增</el-button
          > -->
          <el-button
            @click="newRowHandler"
            v-if="isAdd"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            >新增</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
          <!-- <el-button @click="downLoadTemplate" size="small" type="primary" class="vxe-btn-primary"
            >下载明细行模板</el-button
          >
          <el-button
            @click="importBtnClickHandler"
            size="small"
            type="primary"
            class="vxe-btn-delete"
            >导入明细</el-button
          > -->
        </template>
        <vxe-table-column type="radio" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <el-checkbox v-if="item.editRender.name == 'additional'" v-model="row[item.field]" />
            <span v-else-if="item.editRender.name == 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</span>
            <span v-else-if="item.field == 'currencyCode'">{{
              currencyList?.find((item) => item.value == row['currencyCode'])?.label
            }}</span>
            <span v-else-if="item.field == 'expenseType'">{{
              row['expenseType'] != null && row['expenseType'] != '' ? '押金' : ''
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <!-- 计算说明 -->
            <el-input
              v-if="item.editRender.name == 'settlementDesc'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
              minlength="2"
              maxlength="20"
            ></el-input>
            <!-- 原币结算 -->
            <el-input-number
              :precision="2"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'originalPrice'"
              v-model="row[item.field]"
              disabled
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 结算数量 -->
            <el-input-number
              :precision="4"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'settlementQuantity'"
              v-model="row[item.field]"
              disabled
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 计量单位 -->
            <el-input
              v-if="item.editRender.name == 'unit'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
              disabled
            ></el-input>
            <el-select
              v-if="item.editRender.name == 'unit'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) of basic_unit"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
            <!-- 原币结算金额(含税) -->
            <!-- <el-input-number
              :min="null"
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'originalAmount'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number> -->
            <!-- 币种 -->
            <el-input
              v-if="item.editRender.name == 'currencyName'"
              v-model="row[item.field]"
              disabled
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <el-select
              v-if="item.editRender.name == 'currencyCode'"
              filterable
              clearable
              disabled
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) in currencyList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- 汇率 -->
            <el-input-number
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'exchangeRate'"
              disabled
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 本币结算金额 -->
            <!-- <el-input-number
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'domesticAmount'"
              v-model="row[item.field]"
              disabled
              @input="() => handleChange(row, item.field)"
            ></el-input-number> -->
            <!-- 业务单据编号 -->
            <!-- <el-input
              v-if="item.editRender.name == 'businessDocNo'"
              v-model="row[item.field]"
              maxlength="30"
              @input="() => handleChange(row, item.field)"
            ></el-input> -->
            <!-- 原币结算实际金额 -->
            <el-input-number
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'originalPracticalSettlementAmount'"
              disabled
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 本币结算实际金额 -->
            <el-input-number
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'domesticPracticalSettlementAmount'"
              disabled
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 备注 -->
            <el-input
              v-if="item.editRender.name == 'remark'"
              v-model="row[item.field]"
              maxlength="50"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <!-- 附加 -->
            <el-checkbox v-if="item.editRender.name == 'additional'" v-model="row[item.field]" />
          </template>
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <IPagination
        :total="tableTotal"
        :multipleSelection="selectionList"
        @changePageHandler="changePageHandler"
      />
      <el-upload
        style="display: none"
        ref="siruiUpload"
        :data="importData"
        :action="uploadUrl"
        accept=".xls,.xlsx"
        :before-upload="uploadBefore"
        :on-success="uploadSuccess"
        :show-file-list="false"
        :with-credentials="true"
        :on-error="uploadError"
      >
        <el-button ref="importBtn"></el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
  import { tableColumnList, tableRules } from './index.js';
  import BASEAPI from '@/api/dataBase.js';
  import baseUrl from '@/common/config';
  import PAYABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  // import { map } from 'xe-utils/methods';
  export default {
    name: 'SettleAccountsRow',
    props: {
      baseFormData: {
        type: Object,
        require: true,
      },
      isCreate: {
        type: Boolean,
        require: true,
      },
      // 当前明细表
      currentDetailData: {
        type: Object,
        default: () => {},
      },
      // 详情的时候获取后端数据反填上去
      linesData: {
        type: Array,
        default: () => [],
      },
      settleAccountsDetailMap: {
        type: Map,
        default: () => new Map(),
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        tableRules,
        tableColumnList,
        currencyList: [],
        uploadData: {}, // 上传参数
        uploadUrl: '',
        importData: {}, // 导入参数
        action: '',
        isFetchTableData: false,
        deleteLineIds: [], //删除行的ids
      };
    },
    computed: {
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      tableStatus() {
        return ['detail', 'edit', 'create'].includes(this.$route.query.status) &&
          this.$route.query?.id
          ? this.linesData.length
          : true;
      },
      // 是否显示添加按钮
      isAdd() {
        return (
          this.baseFormData.contractNo.split(',')?.length <= 1 && this.getTableData()?.length < 1
        );
      },
    },
    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['originalAmount'].includes(column.property)) {
              // console.log(this.sumNum(data, column.property), 'this.sumNum(data, column.property)');
              return this.sumNum(data, column.property);
            }
            if (['domesticAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            return null;
          }),
        ];
      },
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          count += +item[field];
        });
        return count > 0 ? count.toFixed(2) : 0;
      },
      //数据校验
      async validAllEvent(isAdd = false) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          isAdd ? this.$message.error('请完善结算行数据') : this.$message.error('请检查数据再提交');
          return true;
        } else {
          return false;
        }
      },
      //是否可以编辑
      activeRowMethod({ columnIndex, row }) {
        if (['create'].includes(this.$route.query?.status) && this.$route.query?.id) {
          if (row?.id) {
            if (
              columnIndex == 22 ||
              columnIndex == 21 ||
              columnIndex == 27 ||
              columnIndex == 2 ||
              columnIndex == 13
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        } else {
          return this.isCreate;
        }
      },
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
      },
      //选择合同移除所有行
      removeRowHandler() {
        let deleteIds = this.getTableData().map((item) => (item.id ? +item.id : null));
        deleteIds = deleteIds.filter((item) => item);
        this.deleteLineIds = this.deleteLineIds.concat(deleteIds);

        const $table = this.$refs.settleAccountsRef;
        $table.remove(this.getTableData()); //先删除表格所有数据
      },
      // 新增行
      async newRowHandler() {
        //默认选中
        let checkLinesRefStatus = await this.validAllEvent(true);
        if (checkLinesRefStatus) {
          return;
        }
        const { currencyCode, currencyName, exchangeRate, contractNo, supplierName, supplierNo } =
          this.baseFormData;
        if (!currencyCode || !currencyName || !exchangeRate || !contractNo) {
          this.$message.error('请补充表单数据');
          return;
        }
        // 先获取表单中的币种和汇率
        // const $table = this.$refs.settleAccountsRef;
        let rowData = { expenseType: '01' };
        // if (['create'].includes(this.$route.query?.status)) {
        if (contractNo.split(',').length <= 1) {
          if (
            ['detail', 'edit', 'create'].includes(this.$route.query.status) &&
            this.$route.query?.id
          )
            rowData = {
              currencyCode,
              currencyName,
              exchangeRate,
              contractNo,
              supplierName,
              supplierNo,
              expenseType: '01',
            };
        } else {
          rowData = { currencyCode, currencyName, exchangeRate, expenseType: '01' };
        }

        console.log(rowData, 'rowData');
        this.insertEvent(rowData, 0);
      },
      async insertEvent(rowData = {}, index = 0) {
        console.log(this.getTableData(), 'this.getTableData()');
        const $table = this.$refs.settleAccountsRef;

        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          //默认选中
          this.selectActiveHandler(this.getTableData()[0]);
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      deleteBtnClickHandler() {
        console.log(this.selectionList, 'this.selectionList');
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        this.$confirm('将同时删除结算明细，确认删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            const xIDList = this.selectionList.map((item) => item._XID);
            // this.selectionList.map((item) => this.deleteLineIds.push(+item.id));

            let deleteIds = this.selectionList.map((item) => (item.id ? +item.id : null));
            deleteIds = deleteIds.filter((item) => item);
            this.deleteLineIds = this.deleteLineIds.concat(deleteIds);
            console.log(this.deleteLineIds, 'this.deleteLineIds');
            this.tableData = this.getTableData().filter((item) => !xIDList.includes(item._XID));
            this.$emit('deleteTableHandler', xIDList, this.tableData);
            // //删除选择行数组
            this.selectionList = [];
            this.$emit('selectionRowHandler', null);
          })
          .catch(() => {});
      },
      //下载模板
      async downLoadTemplate() {
        const { data } = await this.$axios.post(PAYABLES_TRADE.PAYBLES_TEMPLATE_API);
        if (data.code === 0) {
          window.open(data.data, '_blank');
        }
      },
      // 导入
      importBtnClickHandler() {
        if (this.selectionList.length) {
          this.$refs.importBtn.$el.click();
          this.setImport();
        } else {
          this.$message.error('请先选择行,再导入');
        }
      },
      // 设置导入配置
      setImport() {
        this.uploadUrl = baseUrl + '/' + PAYABLES_TRADE.IMPORT_PAYBLES_ACCOUNT_API;
        const { contractNo } = this.baseFormData;
        this.importData = {
          access_token: this.userInfo.access_token,
          selectContractStr: contractNo,
        };
      },
      async selectActiveHandler(row) {
        const $table = this.$refs.settleAccountsRef;
        await $table.setRadioRow(this.getTableData()[0]);
        console.log(row, '选择行变行');
        this.selectionList = [row];
        // 选择行
        this.$emit('selectionRowHandler', row);
      },
      handleSelectionChange({ row }) {
        console.log(row, '选择行');
        this.selectionList = [row];
        // 选择行
        this.$emit('selectionRowHandler', row);
        // const { settlementCompanyNo, settlementDepartmentNo } = this.baseFormData;
        // if (row.contractNo) {
        //   this.$emit('getProductList', settlementCompanyNo, settlementDepartmentNo, row.contractNo);
        // }
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        if (field === 'currencyCode') {
          row['currencyName'] = this.currencyList?.find(
            (item) => item.value == row['currencyCode']
          )?.label;
        } else if (field === 'originalAmount') {
          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;

          row['originalPracticalSettlementAmount'] =
            (row['originalAmount'] - (row['deductAmount'] ?? 0)).toFixed(2) || 0;

          row['domesticPracticalSettlementAmount'] =
            (row['originalPracticalSettlementAmount'] * row['exchangeRate']).toFixed(2) || 0;

          row['originalPracticalAmountWithoutTax'] =
            (row['originalAmountWithoutTax'] - (row['deductAmount'] ?? 0)).toFixed(2) || 0;

          row['domesticPracticalAmountWithoutTax'] =
            (row['originalPracticalAmountWithoutTax'] * row['exchangeRate']).toFixed(2) || 0;
        } else if (field === 'deductAmount') {
          if (row['deductAmount'] > row['originalAmountWithoutTax']) {
            row['deductAmount'] = '';
            this.$message.error('扣除金额不能大于原币结算金额（不含税）');
            return;
          }
          row['originalPracticalSettlementAmount'] =
            (row['originalAmount'] - (row['deductAmount'] ?? 0)).toFixed(2) || 0;

          row['domesticPracticalSettlementAmount'] =
            (row['originalPracticalSettlementAmount'] * row['exchangeRate']).toFixed(2) || 0;

          row['originalPracticalAmountWithoutTax'] =
            (row['originalAmountWithoutTax'] - (row['deductAmount'] ?? 0)).toFixed(2) || 0;

          row['domesticPracticalAmountWithoutTax'] =
            (row['originalPracticalAmountWithoutTax'] * row['exchangeRate']).toFixed(2) || 0;
        } else if (field === 'originalPrice') {
          let _XID = row._XID;
          const lineDetails = this.settleAccountsDetailMap.get(_XID);
          if (!lineDetails?.length) {
            row['originalAmount'] =
              +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';

            row['originalPracticalSettlementAmount'] =
              (row['originalAmount'] - (row['deductAmount'] ?? 0)).toFixed(2) || 0;

            row['domesticPracticalSettlementAmount'] =
              (row['originalPracticalSettlementAmount'] * row['exchangeRate']).toFixed(2) || 0;

            row['originalPracticalAmountWithoutTax'] =
              (row['originalAmountWithoutTax'] - (row['deductAmount'] ?? 0)).toFixed(2) || 0;

            row['domesticPracticalAmountWithoutTax'] =
              (row['originalPracticalAmountWithoutTax'] * row['exchangeRate']).toFixed(2) || 0;
          }
          // console.log(lineDetails, 'lineDetails999999999');
        } else if (field === 'settlementQuantity') {
          let _XID = row._XID;
          const lineDetails = this.settleAccountsDetailMap.get(_XID);
          if (!lineDetails?.length) {
            row['originalAmount'] =
              +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';

            row['originalPracticalSettlementAmount'] =
              (row['originalAmount'] - (row['deductAmount'] ?? 0)).toFixed(2) || 0;

            row['domesticPracticalSettlementAmount'] =
              (row['originalPracticalSettlementAmount'] * row['exchangeRate']).toFixed(2) || 0;

            row['originalPracticalAmountWithoutTax'] =
              (row['originalAmountWithoutTax'] - (row['deductAmount'] ?? 0)).toFixed(2) || 0;

            row['domesticPracticalAmountWithoutTax'] =
              (row['originalPracticalAmountWithoutTax'] * row['exchangeRate']).toFixed(2) || 0;
          }
        } else if (field === 'unit') {
          row['unitName'] = this.basic_unit?.find((item) => item.value == row['unit'])?.label;
        }
      },
      async closeEditTableHandler() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查数据再提交');
        } else {
          // 派发事件
          const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
          const tableData = this.getTableData().map((item) => {
            return {
              ...item,
              currencyCode,
              currencyName,
              exchangeRate,
            };
          });
          this.tableData = tableData;
          this.$emit('closeEditTableHandler', tableData);
          //默认选中
          await $table.setRadioRow(this.getTableData()[0]);
          this.selectActiveHandler(this.getTableData()[0]);
          await $table.clearActived();
        }
      },
      // 获取币种
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          this.currencyList = selectStatus.data.data.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table?.getTableData().fullData;
      },
      // 修改明细表中反填表格数据到表中
      fullTableData(val) {
        console.log(val, '修改明细反填');
        if (!val) return;
        const tableData = this.getTableData();
        const {
          _XID,
          __deduction,
          domesticAmount,
          originalAmount,
          originalPrice,
          settlementQuantity,
          unit,
          businessDocNo,
          originalAmountWithoutTax,
          originalTaxAmount,
          domesticAmountWithoutTax,
          domesticTaxAmount,
        } = val;
        if (__deduction) {
          console.log('11111');
          // 抵扣的时候，并且判重复
          const isExist = tableData.find((item) => item.__deduction == val.__deduction);
          if (!isExist) {
            this.tableData.push(val);
          }
        } else {
          this.tableData = tableData.map((item) => {
            if (item._XID == _XID) {
              return {
                ...item,
                domesticAmount,
                originalAmount,
                originalPrice,
                settlementQuantity,
                unit,
                businessDocNo,
                originalAmountWithoutTax,
                originalTaxAmount,
                domesticAmountWithoutTax,
                domesticTaxAmount,
                originalPracticalSettlementAmount: (
                  originalAmount - (item.deductAmount ?? 0)
                ).toFixed(2),
                domesticPracticalSettlementAmount: (
                  (originalAmount - (item.deductAmount ?? 0)) *
                  item.exchangeRate
                ).toFixed(2),
                originalPracticalAmountWithoutTax: (
                  originalAmountWithoutTax - (item.deductAmount ?? 0)
                ).toFixed(2),
                domesticPracticalAmountWithoutTax: (
                  (originalAmountWithoutTax - (item.deductAmount ?? 0)) *
                  item.exchangeRate
                ).toFixed(2),
              };
            } else {
              return item;
            }
          });
        }

        // 处理结算明细数据变动更新表单
        this.$emit('closeEditTableHandler', this.tableData);
      },
      // 开始上传
      uploadBefore() {
        this.loading.startLoading();
      },
      // 上传成功
      uploadSuccess(response) {
        this.loading.endLoading();
        if (response.code === 0) {
          console.log(response.data, 'response.data');
          if (response.data.length < 1) {
            this.$message.error('不支持的文件内容');
            return;
          }
          this.$message.success('导入成功');
          this.$emit('importData', response.data);
        } else {
          this.$message.error(`${response.msg}`);
        }
      },
      // 上传错误
      uploadError() {
        this.loading.endLoading();
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },

      // 反填远程返回的数据
      fullFetchTableData(val) {
        // 只需要处理一次,采用查重数组或者定义一个变量方式处理
        if (!this.isFetchTableData) {
          this.$nextTick(async () => {
            val.forEach((item) => {
              item.additional = item.additional == 1 ? true : false;
            });
            const $table = this.$refs.settleAccountsRef;
            console.log(val, '查看');
            $table?.insertAt(val, 0);
            // this.tableData = val;
            this.isFetchTableData = true;
            // 处理反填的时候结算明细表
            this.$emit('closeEditTableHandler', this.getTableData(), true);
            //当第一个结算行有明细时默认显示
            if (val[0].lineDetails) {
              this.$emit('selectionRowHandler', this.getTableData()[0]);
              //默认选中
              await $table.setRadioRow(this.getTableData()[0]);
              this.selectActiveHandler(this.getTableData()[0]);
            }
          });
        }
      },
    },
    mounted() {
      this.getCurrencyList();
    },
    watch: {
      currentDetailData: {
        handler(val) {
          this.fullTableData(val);
        },
        // immediate: true,
        deep: true,
      },
      linesData: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            this.fullFetchTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .settle-account-row {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
